import { cn, Input } from "@cmde/shadcn";
import { SearchIcon, XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const disableClearButton = !value || value.length === 0 || disabled;

  return (
    <div className="focus-within:ring-ring flex w-full max-w-[350px] items-center rounded-full border-none bg-black/5 px-3 pl-8 focus-within:ring-3 focus-within:ring-blue-100 dark:bg-white/15 dark:bg-gray-800 dark:focus-within:ring-blue-100">
      <SearchIcon className="text-muted-foreground mr-2 size-4 shrink-0" />
      <Input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        placeholder={placeholder || t("common.searchPlaceholder")}
        className="w-full border-none bg-transparent px-0 shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 dark:bg-transparent"
      />
      <button
        type="button"
        onClick={() => onChange("")}
        disabled={disableClearButton}
        className={cn(
          "text-muted-foreground ml-2 rounded-full p-1 focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:outline-none",
          value && "hover:text-accent",
        )}
      >
        <XIcon className="size-4" />
      </button>
    </div>
  );
};
